import { render, staticRenderFns } from "./ResearchShowPage.vue?vue&type=template&id=1dca31b4&"
import script from "./ResearchShowPage.vue?vue&type=script&lang=js&"
export * from "./ResearchShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports